var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVirusSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0.01,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6441 12.5L18.8566 11.25L15.6254 10.7187V8.125C15.6254 8.075 15.6254 8.03125 15.6254 7.98125L18.7879 7.13125L18.4691 5.925L15.4504 6.73125C15.2448 5.95429 14.8752 5.2304 14.3663 4.60834C13.8575 3.98627 13.2212 3.48047 12.5004 3.125V1.25H11.2504V2.64375C10.4281 2.45207 9.5727 2.45207 8.75039 2.64375V1.25H7.50039V3.125C6.77739 3.4845 6.14026 3.99545 5.63231 4.62311C5.12436 5.25077 4.75749 5.98043 4.55664 6.7625L1.53789 5.925L1.25039 7.13125L4.37539 7.98125C4.37539 8.03125 4.37539 8.075 4.37539 8.125V10.7187L1.15039 11.25L1.35039 12.5L4.37539 11.9875C4.38967 12.7587 4.5642 13.5186 4.88789 14.2187L2.05664 17.0562L2.94414 17.9437L5.56289 15.3187C6.08885 15.9939 6.76196 16.5402 7.53094 16.9159C8.29993 17.2917 9.14452 17.487 10.0004 17.487C10.8563 17.487 11.7009 17.2917 12.4698 16.9159C13.2388 16.5402 13.9119 15.9939 14.4379 15.3187L17.0566 17.9437L17.9441 17.0562L15.1066 14.2187C15.4325 13.519 15.6092 12.7592 15.6254 11.9875L18.6441 12.5ZM9.37539 16.2C8.33502 16.0498 7.38349 15.5301 6.69488 14.7359C6.00627 13.9417 5.62662 12.9262 5.62539 11.875V8.125H9.37539V16.2ZM5.80664 6.875C6.07521 5.97123 6.62855 5.17839 7.38425 4.6146C8.13995 4.05081 9.05756 3.74623 10.0004 3.74623C10.9432 3.74623 11.8608 4.05081 12.6165 4.6146C13.3722 5.17839 13.9256 5.97123 14.1941 6.875H5.80664ZM14.3754 11.875C14.3742 12.9262 13.9945 13.9417 13.3059 14.7359C12.6173 15.5301 11.6658 16.0498 10.6254 16.2V8.125H14.3754V11.875Z",
    fill: "#FF5326"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVirusSmall);
export default __webpack_public_path__ + "static/media/icon_virus_small.16431701230fbedfebd966b6ca356d02.svg";
export { ForwardRef as ReactComponent };